import { useCallback } from "react";

import { SearchTerm } from "@is/types";

type Props = {
  value: SearchTerm;
  onClick: (value: SearchTerm) => void;
};

const useManageAttributeOption = ({ value, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  return {
    handleClick,
  };
};

export default useManageAttributeOption;
